import { render } from "./BlockView.vue?vue&type=template&id=762e4dfa"
import script from "./BlockView.vue?vue&type=script&lang=js"
export * from "./BlockView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__